import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    console.error("ErrorBoundary caught an error", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '20px', background: '#222', color: 'white', minHeight: '100vh', fontFamily: 'sans-serif' }}>
          <h2>Algo salió mal (Error de Aplicación)</h2>
          <details style={{ whiteSpace: 'pre-wrap', color: 'red', background: '#111', padding: '10px' }}>
            <summary>Click para ver detalles del error</summary>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo && this.state.errorInfo.componentStack}
          </details>
          <button onClick={() => { localStorage.clear(); window.location.href = '/'; }} style={{ marginTop: '20px', padding: '10px 20px', fontSize: '16px' }}>
            Borrar datos y Reiniciar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
